import { render, staticRenderFns } from "./ProductFormOptions.vue?vue&type=template&id=5e510354&"
import script from "./ProductFormOptions.vue?vue&type=script&lang=js&"
export * from "./ProductFormOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/parker/lets_code/frances-valentine/new-fv-original/FV-original/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e510354')) {
      api.createRecord('5e510354', component.options)
    } else {
      api.reload('5e510354', component.options)
    }
    module.hot.accept("./ProductFormOptions.vue?vue&type=template&id=5e510354&", function () {
      api.rerender('5e510354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ProductFormOptions.vue"
export default component.exports